module.exports = __webpack_public_path__ + "8ec18a93edda6de7cc07fb9571d32a84.svg";